import { getCookie, setCookie } from 'cookies-next/client'
import { store } from '../_store'
import { getEffectiveSourceId, getMiniAppProvider } from './mini-app'

export const sources = (id: string, is_hall?: boolean) => {
  if (is_hall) return 'hall'
  const platformMap: Record<string, string> = {
    '530ca6f5-0a95-43c3-b9f9-e3756e35065c': 'android',
    '16e13a53-17f5-4736-b1b6-ec168fa25a4e': 'ios',
    '3429e492-5faa-4e17-a19e-b32a4d01b267': 'website',
    '9f053329-38e5-45e8-a9cb-676e277866d3': 'hall',
    '02609982-bd15-41e5-ba06-2cdcb356d5fb': 'bot',
  }

  return platformMap[id] || 'website'
}

const platforms = (id: string, is_hall?: boolean) => {
  if (is_hall) return '9f053329-38e5-45e8-a9cb-676e277866d3'
  const platformMap: Record<string, string> = {
    android: '530ca6f5-0a95-43c3-b9f9-e3756e35065c',
    ios: '16e13a53-17f5-4736-b1b6-ec168fa25a4e',
    website: '3429e492-5faa-4e17-a19e-b32a4d01b267',
    hall: '9f053329-38e5-45e8-a9cb-676e277866d3',
    bot: '02609982-bd15-41e5-ba06-2cdcb356d5fb',
  }

  return platformMap[id || 'website'] || id
}

export const getPlatform = (
  searchParams?: Record<string, string> | undefined | null,
  cookies?: any,
  domain?: string | null
) => {
  const is_hall = searchParams?.is_hall === 'true'

  if (typeof window === 'undefined') {
    const provider = getMiniAppProvider(domain ?? "")
    if (provider === 'click' || provider === 'my_uzbekistan') {
      const source_id = cookies?.get('source_id')?.value
      if (source_id) return source_id
    }
    let platform_id =
      cookies?.get('platform_id')?.value || searchParams?.platform_id || ''
    return platforms(platform_id, is_hall)
  }

  const provider = getMiniAppProvider(domain ?? "")
  if (provider === 'click' || provider === 'my_uzbekistan') {
    const source_id = getEffectiveSourceId(store.getState() as any)
    if (source_id) return String(source_id)
  }

  let platform_id = searchParams?.platform_id
  const cookieValue = getCookie('platform_id')

  if (typeof window !== 'undefined' && !platform_id) {
    platform_id = store.getState()?.session?.platform_id
  }

  if (!platform_id) {
    const searchParams = new URLSearchParams(window.location.search)
    platform_id = searchParams.get('platform_id') || ''
  }

  if (platform_id === '6bd7c2e3-d35e-47df-93ce-ed54ed53f95f') {
    platform_id = '530ca6f5-0a95-43c3-b9f9-e3756e35065c'
  } else if (platform_id === 'f6631db7-09d0-4cd9-a03a-b7a590abb8c1') {
    platform_id = '16e13a53-17f5-4736-b1b6-ec168fa25a4e'
  }

  if (platform_id && platform_id !== cookieValue) {
    setCookie('platform_id', platform_id, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    })
  }

  return platforms(platform_id, is_hall)
}

export const getSource = (
  sp?: { [key: string]: string | undefined } | null,
  cookies?: any
) => {
  const is_hall = sp?.is_hall === 'true'

  if (typeof window === 'undefined') {
    let platform_id =
      cookies?.get('platform_id')?.value || sp?.platform_id || ''
    return sources(platform_id, is_hall)
  }

  let platform_id = getCookie('platform_id') || ''

  if (platform_id === '6bd7c2e3-d35e-47df-93ce-ed54ed53f95f') {
    platform_id = '530ca6f5-0a95-43c3-b9f9-e3756e35065c'
    setCookie('platform_id', platform_id, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    })
  } else if (platform_id === 'f6631db7-09d0-4cd9-a03a-b7a590abb8c1') {
    platform_id = '16e13a53-17f5-4736-b1b6-ec168fa25a4e'
    setCookie('platform_id', platform_id, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    })
  }

  const searchParams = new URLSearchParams(window.location.search)
  const spPlatformId = searchParams.get('platform_id') || ''

  if (spPlatformId && (!platform_id || spPlatformId !== platform_id)) {
    platform_id = spPlatformId
    setCookie('platform_id', spPlatformId, {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    })
  }

  return sources(platform_id, is_hall)
}
